import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onRevertSuccess", "onRevertError"];
import http from 'hub-http/clients/apiClient';
import { registerMutation, useMutation, useDataFetchingClient, registerQuery, useQuery } from 'data-fetching-client';
import { useDispatch } from 'react-redux';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { updateFlowMutationCache } from 'automation-ui-canvas/queries/flowQueries';
export const REVERT_FLOW_CHANGE = registerMutation({
  fieldName: 'revertFlowChange',
  args: ['currentVersion', 'flowId', 'requestType'],
  fetcher(requestParams) {
    return http.post('automationmanagement/v1/revision/revert', {
      data: Object.assign({}, requestParams, {
        execute: true
      }),
      query: {
        sourceApp: WORKFLOWS_APP
      }
    });
  }
});
export const CHECK_REVERT_FLOW_CHANGE_AVAILABLE = registerQuery({
  fieldName: 'checkRevertFlowChangeAvailable',
  args: ['currentVersion', 'flowId', 'requestType'],
  fetcher(requestParams) {
    return http.post('automationmanagement/v1/revision/revert', {
      data: Object.assign({}, requestParams, {
        execute: false
      }),
      query: {
        sourceApp: WORKFLOWS_APP
      }
    });
  }
});
export const useRevertFlowMutation = _ref => {
  let {
      onRevertSuccess = () => {},
      onRevertError = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const dispatch = useDispatch();
  const client = useDataFetchingClient();
  const cache = client.cache;
  const revertFlowMutation = useMutation(REVERT_FLOW_CHANGE, Object.assign({}, rest, {
    onCompleted: data => {
      const response = data.revertFlowChange;
      if (response['@result'] === 'ERR') {
        const revertError = response['@error'];
        onRevertError(revertError);
        return;
      }
      const newFlow = response.hybridFlow;
      const newFlowRecord = new Flow(newFlow);
      updateFlowMutationCache(newFlowRecord, cache, dispatch);
      onRevertSuccess(newFlow);
    }
  }));
  return revertFlowMutation;
};
export const wasRevertSuccessful = function wasRevertSuccessful(data) {
  if (data && data.revertFlowChange['@result'] === 'OK') {
    return true;
  }
  return false;
};
export const useIsRevertAvailable = params => {
  const {
    data,
    loading
  } = useQuery(CHECK_REVERT_FLOW_CHANGE_AVAILABLE, params);
  if (loading || !data) {
    return {
      isRevertAvailable: false
    };
  }
  const response = data.checkRevertFlowChangeAvailable;
  if (response['@result'] === 'ERR') {
    return {
      isRevertAvailable: false,
      revertError: response['@error']
    };
  }
  return {
    isRevertAvailable: true
  };
};